import React from "react";
import { Helmet } from "react-helmet";

function AtmAndBanks() {
  return (
		<>
			<Helmet>
				<title>VBU - ATM & Banks</title>
			</Helmet>
			<div className="PageContainer">
				<div className="Campus">
					<div id="Heading">
						<h1>ATM & Banks</h1>
					</div>

					<div className="Desc">
						<div className="DescParagraph" style={{ width: '100%' }}>
							<p>
								To effectively cater to the everyday financial requirements of students, faculty, and administrative staff, the university campus is meticulously equipped with robust banking facilities and multiple 24x7 Automated Teller Machines (ATMs). 
								<br />
								<br />
								These conveniently located on-campus financial services assure completely safe, fast, and easily accessible monetary transactions without the need to travel far into the city. A dedicated branch of a nationalized bank operates directly within the campus premises, providing comprehensive assistance with educational loans, student savings accounts, immediate fee deposits, and diverse general financial inquiries.
								<br />
								<br />
								The ATMs are strategically positioned near major academic blocks and the primary administrative building, functioning round-the-clock and manned by dedicated security personnel to ensure utmost safety and uninterrupted access for the entire university community.
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default AtmAndBanks;
